import { useAtom } from '@reatom/npm-react'
import { createGlobalStyle } from 'styled-components'

import { currentThemeAtom } from '@root/shared/theme/atoms/current-theme-atom'

import { themeVariablesCss } from '../../shared/ui-kit/theme'

import type { Theme as DelugeTheme } from '@blade/ui-theme'

type GlobalCssProps = {
  $uiTheme: DelugeTheme
}

const GlobalStyles = createGlobalStyle<GlobalCssProps>`
  :root {
    --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
    --safe-area-inset-top: env(safe-area-inset-top, 0px);
    --safe-bottom: max(env(safe-area-inset-bottom, 34px), 34px);
    --safe-top: env(safe-area-inset-top, 0px);

    --mobile-background: var(--appearanceA-7);

    ${({ $uiTheme }) => themeVariablesCss($uiTheme)}

  }

  html {
    overflow: hidden;
    background: var(--appearance-1);

    body {
      --safe-bottom: 12px;
      font-family: 'Inter';
      color: var(--text-12);
      overflow: hidden;
      background: transparent;

      &[data-platform='ios'] {
        --safe-bottom: 34px;
        --safe-top: max(env(safe-area-inset-top, 47px), 47px);
      }
      &[data-scroll-locked] {
        padding-top: 0;
      }
    }
  }

  #root {
    height: 100%;
    overflow: hidden;
    position: relative;
    background: var(--appearance-1);
    transition: opacity 0.15s ease-in-out;
  }

  *:not(input):not(textarea) {
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
  }

  a {
    text-decoration: none;
  }

  input {
    caret-color: var(--primary-9);

    &::placeholder {
      color: var(--textA-8);
      font-weight: 400;
      line-height: 20px;
    }

    &::selection {
      background-color: var(--backgroundA-7);
    }
  }

  ::-webkit-scrollbar-track {
    background: var(--backgroundA-2);

    &:hover {
      background: var(--backgroundA-3);
    }
  }

  ::-webkit-scrollbar-thumb {
    background: var(--backgroundA-3);

    &:hover {
      background: var(--backgroundA-5);
    }
  }
`

export const AppGlobalStyles = () => {
  const [currentTheme] = useAtom(currentThemeAtom)

  return <GlobalStyles $uiTheme={currentTheme} />
}
